module.exports = __webpack_public_path__ + "img/12-30-166.6174e76f.jpg";